import { ROUTE_NAMES } from '@/utils/const.js';
import { USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';
const Output = () => import('./pages');

const moduleRoute = {
  path: '/output',
  name: 'Output',
  component: Output,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.OUTPUTS,
      action: USER_ACTIONS.READ,
    },
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
